"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M21 5h-3v14h3zm-4 0H7v14h10zM6 5H3v14h3z"
}), 'ViewArraySharp');